import { createBrowserHistory } from 'history';
let historyConfig = {};
const history = createBrowserHistory(historyConfig);
export { history };
